var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 13,
    height: 13,
    transform: "translate(601 174)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_36",
    "data-name": "Mask Group 36",
    transform: "translate(-601 -174)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(601 174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M15.9,14.307l4.449-4.449a1.125,1.125,0,1,0-1.589-1.592l-4.449,4.449L9.858,8.266A1.126,1.126,0,0,0,8.266,9.858l4.449,4.449L8.266,18.755a1.126,1.126,0,0,0,1.592,1.592L14.307,15.9l4.449,4.449a1.126,1.126,0,0,0,1.592-1.592Z",
    transform: "translate(-7.936 -7.936)",
    fill: "#4d586a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.2ba9e7078ac21099500fefabf7f210b4.svg";
export { ForwardRef as ReactComponent };